/* ==========================================================================
   MeloKeeps v3 · Shopify 交互
   --------------------------------------------------------------------------
   做四件事：
     1. 购物袋 —— 用 Shopify 原生 Cart API（/cart.js、/cart/add.js、/cart/change.js），
        结账跳真实 /checkout
     2. 产品页变体切换 —— 读 #mk-editions 里的 JSON，换主图 / 缩略图 / 价格 / 文案
     3. 图片放大
     4. 底部吸底购买条

   变体数据由 sections/mk-product.liquid 生成，价格与库存永远以 Shopify 为准。
   ========================================================================== */
(() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD',
  }).format((Number(cents) || 0) / 100);

  /* ============================================================
   * 浮层
   * ============================================================ */
  function openDialog(d) {
    if (!d || d.open) return;
    d.showModal();
    document.body.classList.add('modal-open');
  }
  function closeDialog(d) {
    if (d && d.open) d.close();
  }

  $$('dialog').forEach((d) => {
    d.addEventListener('close', () => document.body.classList.remove('modal-open'));
    d.addEventListener('click', (e) => {
      if (e.target !== d) return;
      const r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(d);
    });
  });

  /* ============================================================
   * 购物袋 —— Shopify Cart API
   * ============================================================ */
  const cartDialog = $('#cart-dialog');
  const cartItems = $('[data-mk-cart-items]');
  const cartSummary = $('[data-mk-cart-summary]');
  const subtotalEl = $('[data-mk-cart-subtotal]');
  const shopUrl = (cartItems && cartItems.dataset.mkShopUrl) || '/collections/all';

  function paintCount(n) {
    $$('[data-mk-cart-count]').forEach((el) => { el.textContent = n; });
  }

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('cart read failed');
    return res.json();
  }

  async function postCart(path, body) {
    const res = await fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok) throw new Error((data && data.description) || 'cart update failed');
    return data;
  }

  function renderCart(cart) {
    paintCount(cart.item_count);

    if (!cartItems) return;

    if (!cart.items.length) {
      cartItems.innerHTML =
        '<div class="empty-cart"><p>Your bag is waiting for a little music.</p>' +
        '<a class="button secondary" href="' + esc(shopUrl) + '">Choose an artist</a></div>';
      if (cartSummary) cartSummary.hidden = true;
      return;
    }

    if (cartSummary) cartSummary.hidden = false;
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    cartItems.innerHTML = cart.items.map((item) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return '' +
        '<article class="cart-item" data-key="' + esc(item.key) + '">' +
          (item.image
            ? '<img src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" width="120" height="120" loading="lazy">'
            : '') +
          '<div>' +
            '<h3>' + esc(item.product_title) + '</h3>' +
            '<p>' + (variant ? esc(variant) + ' · ' : '') + '9 mini records</p>' +
            '<span class="cart-item-price">' + money(item.final_line_price) + '</span>' +
            '<div class="cart-item-bottom">' +
              '<div class="quantity-control">' +
                '<button type="button" data-action="minus" aria-label="Decrease quantity"' +
                  (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
                '<span class="cart-qty" aria-label="Quantity">' + item.quantity + '</span>' +
                '<button type="button" data-action="plus" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button class="remove-item" data-action="remove" type="button">Remove</button>' +
            '</div>' +
          '</div>' +
        '</article>';
    }).join('');
  }

  async function refreshCart() {
    try {
      renderCart(await getCart());
    } catch (e) {
      /* 读不到购物袋时不要把页面搞坏 */
    }
  }

  $$('[data-mk-cart-open]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      await refreshCart();
      openDialog(cartDialog);
    });
  });

  const closeCart = $('#close-cart');
  if (closeCart) closeCart.addEventListener('click', () => closeDialog(cartDialog));

  if (cartItems) {
    cartItems.addEventListener('click', async (e) => {
      const btn = e.target.closest('button[data-action]');
      if (!btn) return;
      const row = btn.closest('.cart-item');
      if (!row) return;
      const key = row.dataset.key;
      const qtyEl = row.querySelector('.cart-qty');
      const qty = qtyEl ? Number(qtyEl.textContent) : 1;
      const action = btn.dataset.action;

      btn.disabled = true;
      try {
        if (action === 'remove') {
          renderCart(await postCart('/cart/change.js', { id: key, quantity: 0 }));
        } else {
          const next = Math.max(1, Math.min(99, qty + (action === 'plus' ? 1 : -1)));
          renderCart(await postCart('/cart/change.js', { id: key, quantity: next }));
        }
        const restored = cartItems.querySelector('[data-key="' + CSS.escape(key) + '"] [data-action="' + action + '"]');
        if (restored && !restored.disabled) restored.focus();
      } catch (err) {
        btn.disabled = false;
      }
    });
  }

  /* ============================================================
   * 图片放大
   * ============================================================ */
  const imageDialog = $('#image-dialog');
  const enlarged = $('#enlarged-image');
  const closeImage = $('#close-image');
  if (closeImage) closeImage.addEventListener('click', () => closeDialog(imageDialog));

  /* ============================================================
   * 产品页
   * ============================================================ */
  const editionsEl = $('#mk-editions');
  const form = $('[data-mk-product-form]');

  if (editionsEl && form) {
    let editions = [];
    try { editions = JSON.parse(editionsEl.textContent) || []; } catch (e) { editions = []; }

    const VIEW_LABELS = ['Player', 'Complete set', 'Nine records', 'Product details'];

    const mainImage = $('#main-image');
    const thumbs = $('[data-mk-thumbs]');
    const priceEl = $('[data-mk-price]');
    const priceNoteEl = $('[data-mk-price-note]');
    const selectedTitleEl = $('[data-mk-selected-title]');
    const selectionNoteEl = $('[data-mk-selection-note]');
    const captionEl = $('[data-mk-caption]');
    const galleryNoteEl = $('[data-mk-gallery-note]');
    const customBox = $('[data-mk-custom]');
    const addBtn = $('[data-mk-add]');
    const stickyTitle = $('[data-mk-sticky-title]');
    const stickyPrice = $('[data-mk-sticky-price]');
    const storyImage = $('#story-image');
    const qtyInput = $('[data-mk-qty]');
    const qtyDown = $('[data-mk-qty-down]');
    const qtyUp = $('[data-mk-qty-up]');

    const checked = $('input[name="id"]:checked');
    let current = editions.find((e) => e.id === Number(checked && checked.value)) || editions[0];
    let view = 0;

    function galleryOf(ed) {
      const list = (ed.images || []).filter(Boolean);
      return list.length ? list : (ed.fallback ? [ed.fallback] : []);
    }

    function renderThumbs(ed) {
      if (!thumbs) return;
      const list = galleryOf(ed);
      if (list.length <= 1) {
        thumbs.hidden = true;
        thumbs.innerHTML = '';
        return;
      }
      thumbs.hidden = false;
      thumbs.innerHTML = list.map((src, i) =>
        '<button class="thumbnail" type="button" data-view="' + i + '"' +
        ' aria-label="Show ' + esc(VIEW_LABELS[i] || 'Image ' + (i + 1)) + '"' +
        ' aria-pressed="' + (i === view) + '">' +
        '<img src="' + esc(src) + '" alt="" width="60" height="60" loading="lazy"></button>'
      ).join('');
    }

    function render() {
      if (!current) return;
      const list = galleryOf(current);
      const src = list[view] || list[0] || '';

      if (mainImage && src) {
        mainImage.src = src;
        mainImage.alt = current.title + ' edition MeloKeeps music box';
      }

      if (selectedTitleEl) selectedTitleEl.textContent = current.title;

      if (priceEl) priceEl.textContent = current.pending ? current.pendingLabel : current.priceMoney;
      if (priceNoteEl && current.priceNote) priceNoteEl.textContent = current.priceNote;
      if (selectionNoteEl && current.selectionNote) selectionNoteEl.textContent = current.selectionNote;
      if (captionEl && current.caption) captionEl.textContent = current.caption;
      if (galleryNoteEl && current.galleryNote) galleryNoteEl.textContent = current.galleryNote;

      if (stickyTitle) stickyTitle.textContent = current.title;
      if (stickyPrice) stickyPrice.textContent = current.pending ? current.pendingLabel : current.priceMoney;

      if (storyImage && list.length > 2) {
        storyImage.src = list[2];
        storyImage.alt = 'Nine ' + current.title + ' edition mini records';
      }

      if (customBox) customBox.hidden = !current.pending;

      if (addBtn) {
        addBtn.disabled = !!current.pending || !current.available;
        addBtn.innerHTML = current.pending
          ? esc(current.pendingLabel)
          : (current.available
            ? 'Add to bag <span aria-hidden="true">&#8599;</span>'
            : 'Sold out');
      }

      renderThumbs(current);
    }

    form.addEventListener('change', (e) => {
      const input = e.target.closest('input[name="id"]');
      if (!input) return;
      const next = editions.find((x) => x.id === Number(input.value));
      if (!next) return;
      current = next;
      view = 0;
      render();
      const url = new URL(location.href);
      url.searchParams.set('variant', String(current.id));
      history.replaceState(null, '', url);
    });

    if (thumbs) {
      thumbs.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-view]');
        if (!btn) return;
        view = Number(btn.dataset.view) || 0;
        const list = galleryOf(current);
        if (mainImage && list[view]) {
          mainImage.src = list[view];
          mainImage.alt = current.title + ' edition MeloKeeps — ' + (VIEW_LABELS[view] || '');
        }
        Array.from(thumbs.querySelectorAll('button')).forEach((b) => {
          b.setAttribute('aria-pressed', String(Number(b.dataset.view) === view));
        });
      });
    }

    const zoomBtn = $('[data-mk-zoom]');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', () => {
        if (enlarged && mainImage) {
          enlarged.src = mainImage.src;
          enlarged.alt = mainImage.alt;
        }
        openDialog(imageDialog);
      });
    }

    /* 数量 1–10 */
    const clampQty = (v) => Math.max(1, Math.min(10, Math.floor(Number(v) || 1)));
    function setQty(v) {
      if (!qtyInput) return;
      qtyInput.value = clampQty(v);
      if (qtyDown) qtyDown.disabled = Number(qtyInput.value) <= 1;
      if (qtyUp) qtyUp.disabled = Number(qtyInput.value) >= 10;
    }
    if (qtyDown) qtyDown.addEventListener('click', () => setQty(Number(qtyInput.value) - 1));
    if (qtyUp) qtyUp.addEventListener('click', () => setQty(Number(qtyInput.value) + 1));
    if (qtyInput) qtyInput.addEventListener('change', () => setQty(qtyInput.value));
    setQty(1);

    /* 加购：拦截表单，走 Cart API，弹出购物袋 */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!current || current.pending || !current.available) return;

      const qty = clampQty(qtyInput ? qtyInput.value : 1);
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
      }

      try {
        await postCart('/cart/add.js', { items: [{ id: current.id, quantity: qty }] });
        await refreshCart();
        openDialog(cartDialog);
      } catch (err) {
        /* 失败时退回原生表单提交，至少不会静默丢失 */
        form.submit();
        return;
      } finally {
        render();
      }
    });

    /* 底部吸底购买条 */
    const sticky = $('[data-mk-sticky]');
    if (sticky) {
      let formVisible = true;
      let footerVisible = false;
      const sync = () => { sticky.hidden = formVisible || footerVisible; };
      const footer = document.querySelector('.mk-page .site-footer');
      new IntersectionObserver((entries) => {
        formVisible = entries[0].isIntersecting;
        sync();
      }, { threshold: 0 }).observe(form);
      if (footer) {
        new IntersectionObserver((entries) => {
          footerVisible = entries[0].isIntersecting;
          sync();
        }, { threshold: 0 }).observe(footer);
      }
      sync();
    }

    render();
  }

  /* 首次进入时同步一次购物袋数量 */
  refreshCart();
})();
